<template>
  <div class="m-edition-map-tasks-record">
    <div
      v-if="showLoadingState"
      key="loadingTask"
    >
      <p class="margin-top-xxlarge text-align-center">
        Cargando datos...
      </p>
    </div>
    <div
      v-else-if="taskInList.nodo_activo_tarea"
      key="taskLoaded"
    >
      <div class="tasks-record-header">
        <h2>
          {{ $store.getters.getAssetSelectedTaskInList.nodo_titulo }}
        </h2>
        <span
          v-show="task.estado.estado === 1"
          class="task-points"
        >
          <span class="margin-right-xsmall">{{ task.puntaje }}</span>
          <i class="fas fa-star text-color-notifications-primary"></i>
        </span>
        <form
          v-show="task.estado.estado === 0"
          autocomplete="off"
          name="editor-form"
          @submit.prevent="aproveTask(1)"
        >
          <AtomButtonSecondary
            :button-secondary="buttonSecondary.rejectTask"
            :disabled="buttonPrimary.sending || buttonSecondary.rejectTask.sending"
            :element="task"
            :show-loading="buttonSecondary.rejectTask.sending"
            @rejectTask="rejectTask(2)"
          />
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="buttonPrimary.sending || buttonSecondary.rejectTask.sending"
          />
        </form>
        <span
          v-show="task.estado.estado === 2"
          class="task-state-rejected"
        >
          <i class="far fa-times"></i> Rechazada
        </span>
      </div>

      <MoleculeContentNode :is-task="true"/>

      <div class="m-edition-map-tasks-record-messages">
        <div
          v-for="mensaje in task.mensajes"
          :key="mensaje.id"
          class="task-record-message"
        >
          <span class="task-record-message-avatar">
            <img
              class="a-avatar-primary"
              :src="mensaje.avatar"
            />
          </span>
          <span class="task-record-message-text">
            <span class="task-record-message-text-name">
              {{ mensaje.razon_social }}
            </span>
            <span>
              {{ mensaje.mensaje }}
            </span>
          </span>
        </div>

        <div class="task-record-write-message">
          <span class="task-record-write-message-avatar">
            <img
              class="a-avatar-primary"
              :src="userAvatar"
            />
          </span>
          <div class="task-record-write-message-text">
            <form
              autocomplete="off"
              @submit.prevent="false"
            >
              <AtomTextAreaPrimary
                v-model="messageData.tarea_mensaje.mensaje"
                :disabled="sendingMessage"
                maxlength="255"
                placeholder="Escribe aquí un mensaje"
              />
              <div class="message-text-actions">
                <a
                  class="send-message"
                  href="#"
                  @click.prevent="createInscripcionNodoActivoTareaMensaje()"
                >
                 <i :class="sendingMessage
                    ? 'fas fa-spinner fa-spin'
                    : 'far fa-location-arrow'"
                  >
                  </i> Enviar
                </a>
                <span class="message-text-length">
                  {{ messageData.tarea_mensaje.mensaje.length }} / 255
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>

      <MoleculeContentNode :is-task="false"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionMapTasksRecord',

  components: {
    MoleculeContentNode: () => import('@/components/molecules/MoleculeContentNode')
  },

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: 'Aceptar',
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        rejectTask: {
          class: 'a-button-secondary a-button-reset-secondary display-flex-row-center margin-right-small',
          component: '',
          icon: 'far fa-times',
          method: 'rejectTask',
          sending: false,
          text: 'Rechazar',
          type: 'button'
        }
      },

      messageData: {
        academia: '',
        nodo: '',

        tarea_mensaje: {
          mensaje: '',
          nodo_activo_tarea: 0
        }
      },

      sendingMessage: false,
      showLoadingState: true,

      student: {
        avatar: '@/assets/img/avatar.png',
        razon_social: ''
      },

      userAvatar: '@/assets/img/avatar.png',
      task: {}
    }
  },

  computed: {
    taskInList () {
      return this.$store.getters.getAssetSelectedTaskInList
    }
  },

  watch: {
    taskInList () {
      this.task = {}
      this.resetMessageData()
      if (this.taskInList.nodo_activo_tarea) {
        this.showLoadingState = true
        this.student = {
          avatar: this.$store.getters.getAssetSelectedTaskInList.avatar,
          razon_social: this.$store.getters.getAssetSelectedTaskInList.razon_social
        }
        this.readInscripcionNodoActivoTarea()
      } else {
        this.showLoadingState = false
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.userAvatar = this.$store.getters.getUserData.vidroop_data
      ? this.$store.getters.getUserData.vidroop_data.avatar
      : this.$store.getters.getUserData.picture
        ? this.$store.getters.getUserData.picture
        : '@/assets/img/avatar.png'
  },

  methods: {
    aproveTask (estado) {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.updateInscripcionNodoActivoTareaEstado(estado)
      }
    },

    createInscripcionNodoActivoTareaMensaje () {
      if (!this.sendingMessage && this.messageData.tarea_mensaje.mensaje !== '') {
        this.sendingMessage = true
        this.messageData = {
          academia: this.academiaId,
          nodo: this.$store.getters.getAssetSelectedTaskInList.nodo,

          tarea_mensaje: {
            mensaje: this.messageData.tarea_mensaje.mensaje,
            nodo_activo_tarea: this.$store.getters.getAssetSelectedTaskInList.nodo_activo_tarea
          }
        }

        this.$services.create('inscripcion', 'createInscripcionNodoActivoTareaMensaje', this.messageData,
          [this.$store.getters.getAssetSelectedTaskInList.inscripcion])
          .then(response => {
            // this.task.mensajes = [...response.data.mensajes]
            this.messageData.tarea_mensaje.mensaje = ''
            this.readInscripcionNodoActivoTareaMensajes()
            // this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'success')
            this.sendingMessage = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'error', 'a-alert-danger')
            this.sendingMessage = false
          })
      }
    },

    readInscripcionNodoActivoTarea () {
      this.showLoadingState = true
      let endpointFilter = {
        academia: this.academiaId,
        nodo: this.$store.getters.getAssetSelectedTaskInList.nodo,
        nodo_activo_tarea: this.$store.getters.getAssetSelectedTaskInList.nodo_activo_tarea
      }

      this.$services.read('inscripcion', 'readInscripcionNodoActivoTarea', {},
        [this.$store.getters.getAssetSelectedTaskInList.inscripcion], endpointFilter)
        .then(response => {
          this.task = Object.assign({}, response.data)
          this.readInscripcionNodoActivoTareaMensajes()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    readInscripcionNodoActivoTareaMensajes () {
      let endpointFilter = {
        academia: this.academiaId,
        nodo: this.$store.getters.getAssetSelectedTaskInList.nodo,
        nodo_activo_tarea: this.$store.getters.getAssetSelectedTaskInList.nodo_activo_tarea
      }

      this.$services.read('inscripcion', 'readInscripcionNodoActivoTareaMensajes', {},
        [this.$store.getters.getAssetSelectedTaskInList.inscripcion], endpointFilter)
        .then(response => {
          this.task.mensajes = [...response.data.mensajes]
          this.$store.commit('setAssetSelectedTask', Object.assign({}, this.task))
          this.setSelectedNode()
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    rejectTask (estado) {
      if (!this.buttonSecondary.rejectTask.sending) {
        this.buttonSecondary.rejectTask.sending = true
        this.updateInscripcionNodoActivoTareaEstado(estado)
      }
    },

    resetMessageData () {
      this.messageData = {
        academia: '',
        nodo: '',

        tarea_mensaje: {
          mensaje: '',
          nodo_activo_tarea: 0
        }
      }
    },

    setSelectedNode () {
      let proyectNodes = [...this.$store.getters.getAssetNodes]

      proyectNodes.every((pNode, index) => {
        let returnState = true
        if (pNode.id === this.$store.getters.getAssetSelectedTaskInList.nodo) {
          this.$store.commit('setAssetSelectedNode', Object.assign({}, pNode))
          returnState = false
        } else {
          pNode.children.every((pNodeChild, indexChild) => {
            if (pNodeChild.id === this.$store.getters.getAssetSelectedTaskInList.nodo) {
              this.$store.commit('setAssetSelectedNode', Object.assign({}, pNodeChild))
              returnState = false
            }
            return returnState
          })
        }
        return returnState
      })
    },

    updateInscripcionNodoActivoTareaEstado (estado) {
      let endpointData = {
        academia: this.academiaId,
        estado: estado,
        nodo: this.$store.getters.getAssetSelectedTaskInList.nodo,
        nodo_activo_tarea: this.$store.getters.getAssetSelectedTaskInList.nodo_activo_tarea
      }

      this.$services.create('inscripcion', 'updateInscripcionNodoActivoTareaEstado', endpointData,
        [this.$store.getters.getAssetSelectedTaskInList.inscripcion])
        .then(response => {
          this.$emit('readTasksList')
          this.buttonSecondary.rejectTask.sending = false
          this.buttonPrimary.sending = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
